import React from 'react';

const ReturnsPage: React.FC = () => {
  return (
    <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12 md:py-16">
      <h1 className="text-3xl md:text-4xl font-serif font-bold text-navy-900 mb-6">
        Returns Policy
      </h1>
      <div className="prose prose-lg max-w-none">
        <p className="text-gray-700 leading-relaxed mb-4">
          This returns policy page is currently being prepared. Please contact us at{' '}
          <a href="mailto:quirketrophies@mail.com" className="text-gold-600 hover:text-gold-700 underline">
            quirketrophies@mail.com
          </a>{' '}
          or call (052) 743 0288 if you need to return an item or have questions about our returns process.
        </p>
        <p className="text-gray-700 leading-relaxed">
          We want you to be completely satisfied with your purchase. If you have any concerns, please don't hesitate to contact us.
        </p>
      </div>
    </div>
  );
};

export default ReturnsPage;

